<script lang="ts" setup></script>

<template>
  <NuxtLoadingIndicator color="oklch(68.47% 0.1479 237.32)" />
  <div class="divide-y divide-gray-300">
    <AppHeader />
    <slot />
  </div>
</template>

<style></style>
